/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { InbOrd03Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const inbOrd03ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const inbOrd03FetchInbOrd03Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const inbOrd03FetchInbOrd03Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const inbOrd03AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const inbOrd03RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const inbOrd03SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const inbOrd03CreateInbOrd03Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const inbOrd03CreateInbOrd03Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [InbOrd03Types.INB_ORD03_RESET_TIMESTAMP]: inbOrd03ResetTimestamp,
  [InbOrd03Types.INB_ORD03_FETCH_INB_ORD03_LOADING]: inbOrd03FetchInbOrd03Loading,
  [InbOrd03Types.INB_ORD03_FETCH_INB_ORD03_SUCCESS]: inbOrd03FetchInbOrd03Success,
  [InbOrd03Types.INB_ORD03_ADD_SELECTED_DOCUMENTS]: inbOrd03AddSelectedDocuments,
  [InbOrd03Types.INB_ORD03_REMOVE_SELECTED_DOCUMENTS]: inbOrd03RemoveSelectedDocuments,
  [InbOrd03Types.INB_ORD03_SET_WORKSPACE_VISIBLE]: inbOrd03SetWorkspaceVisible,
  [InbOrd03Types.INB_ORD03_CREATE_INB_ORD03_LOADING]: inbOrd03CreateInbOrd03Loading,
  [InbOrd03Types.INB_ORD03_CREATE_INB_ORD03_SUCCESS]: inbOrd03CreateInbOrd03Success
});
